<template lang="pug">
  .component-create-instruction
    .row
      .columns
        label Title
          input(type="text", v-model="instruction.title")
      .columns
        label Subtitle
          input(type="text", v-model="instruction.subtitle")
    .row
      .columns
        ActionBar
          .title(slot="title") Steps
          .action(slot="action", @click="addStep")
            i.fa.fa-plus

        InstructionStep(v-for="(step, index) in instruction.steps", :key="Math.random()", :step="step", @remove="removeStep(index)", @resetValue="resetStep(index)" )
    .row.columns(style="margin-top:10px")
      .text-right
        button.button(@click="saveInstruction") Save
</template>
<script type="text/babel">

  import KeplerBackofficeSdk from '../../lib/kepler/backoffice'
  import KeplerFileUpload from '../../components/structure/KeplerFileUpload'
  import Editor from '../../components/structure/ui/Editor'
  import ActionBar from '../../components/structure/ui/ActionBar'
  import InstructionStep from '../../components/structure/ui/InstructionStep'
  import MaggieHelper from '../../maggieHelper'

  export default {
    name: 'CreateInstruction',
    components: {InstructionStep, ActionBar, Editor, KeplerFileUpload},
    data() {
      return {
        instruction: {
          title: null,
          subtitle: null,
          steps: [
            {
              type: 'html',
              value: ''
            }
          ]
        }
      }
    },
    computed: {},
    mounted() {
    },
    created() {
      if (this.$route.params.id) {
        KeplerBackofficeSdk.instructions.select(this.$route.params.id).get((data) => {
          this.instruction = data
          this.instruction.steps = data.steps.map((item) => {
            if (item.type === 'image' && item.value.split('|').length == 2) {
              const value = item.value.split('|')
              return {type: 'linked_image', image_url: value[0], image_link: value[1]}
            }

            return item
          })

        })
      }
    },
    methods: {
      addStep() {
        this.instruction.steps.push({
          type: 'html',
          value: ''
        })
      },
      removeStep(index) {
        this.instruction.steps.splice(index, 1)
      },
      resetStep(index) {
        this.instruction.steps[index].value = ''
      },
      saveInstruction() {

        this.instruction.steps = this.instruction.steps.map((item) => {
          if (item.type === 'linked_image') {
            return {type: 'image', value: `${item.image_url}|${item.image_link}`}
          }
          return item
        })

        if (this.$route.params.id) {
          KeplerBackofficeSdk.instructions.select(this.$route.params.id).edit(this.instruction, (data) => {
            this.instruction = data
            MaggieHelper.notification('Edited', 'Instruction Edited')
            this.$router.push({name: 'instructions'})
          })

          return
        }
        KeplerBackofficeSdk.instructions.make(this.instruction, (data) => {
          MaggieHelper.notification('Created', 'Instruction Created')
          this.$router.push({name: 'instructions'})
        })
      }
    },
  }
</script>
<style lang="sass" rel="stylesheet/sass">
  .component-create-instruction
    background: white
    padding: 20px


</style>



// WEBPACK FOOTER //
// CreateInstruction.vue?0b0abd9e